var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25766 0.631539C6.3744 -0.210107 4.94184 -0.210576 4.05792 0.63051L3.63546 1.03251C2.83192 0.815025 1.93293 1.00965 1.30022 1.61628C0.366594 2.51148 0.366594 3.96434 1.30022 4.85954L1.8 5.33874V11.4286H0V12.5714H3.89697C3.508 12.9345 3.26667 13.4404 3.26667 14C3.26667 15.1046 4.20687 16 5.36667 16C6.52647 16 7.46667 15.1046 7.46667 14C7.46667 13.4404 7.22535 12.9345 6.83637 12.5714H17.1636C16.7747 12.9345 16.5333 13.4404 16.5333 14C16.5333 15.1046 17.4735 16 18.6333 16C19.7931 16 20.7333 15.1046 20.7333 14C20.7333 13.4404 20.492 12.9345 20.103 12.5714H24V11.4286H21.6V9.64988C22.6331 9.40834 23.4 8.51388 23.4 7.44743C23.4 6.1956 22.3433 5.1808 21.0397 5.1808H8.466C8.4171 5.1808 8.37012 5.16211 8.3355 5.12891L8.11566 4.91817L8.3367 4.70783C9.22068 3.86668 9.22116 2.50245 8.33778 1.66074L7.25766 0.631539ZM7.27002 4.10731L7.48854 3.89937C7.90362 3.5044 7.90386 2.86388 7.48908 2.46868L6.40896 1.43948C5.99412 1.04417 5.32122 1.04394 4.90608 1.43897L4.69578 1.63908L7.27002 4.10731ZM20.4 11.4286H3V6.48931L6.16512 9.52411C6.29202 9.64577 6.46398 9.71411 6.64332 9.71411H20.4V11.4286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.ebdf5b12efcf604661b3efa8b2e721b2.svg";
export { ForwardRef as ReactComponent };